import {Button, Form, Input, message} from 'antd'
import React, {useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useRevalidator, useSubmit} from 'react-router-dom'
import {Project} from '../../entities/project'
import {useCurrentUser} from '../../hooks/useCurrentUser'
import {instance as projectsService} from '../../services/ProjectsService'
import {ImageSelect} from '../imageSelect/ImageSelect'
import urlProjectPhoto0 from 'url:../../../public/assets/images/image1.jpg'
import urlProjectPhoto1 from 'url:../../../public/assets/images/pexels-eberhard-grossgasteiger-1612351.jpg'
import urlProjectPhoto2 from 'url:../../../public/assets/images/pexels-pixabay-462118.jpg'
import urlProjectPhoto3 from 'url:../../../public/assets/images/pexels-scott-webb-1029599.jpg'
import '../canvas/editors/EditorCreateElements.less'
import {LocationInput} from './LocationInput'
import {MapImage, MapImageExtractor} from './EditorProjectMap'
import {InfoCircleOutlined} from '@ant-design/icons'

export type GeneralProjectInfoFormProps = {
  project: Project
}

const getLocalization = (local: any) => {
  return local
}

export function GeneralProjectInfoForm({project}: GeneralProjectInfoFormProps) {
  const [form] = Form.useForm()
  const user = useCurrentUser()
  const navigate = useNavigate()
  const submit = useSubmit()
  const revalidator = useRevalidator()
  const [messageApi, contextHolder] = message.useMessage()
  const intl = useIntl()
  const imageExtractorRef = useRef<MapImageExtractor | null>(null)

  const validateMessages = {
    required: intl.formatMessage({id: 'requiredField'}),
  }

  useEffect(() => {
    form.setFieldsValue(
      project === null
        ? {}
        : {
            name: project?.name,
            description: project?.description,
            projectImage: project?.photo,
            //coordinates: project?.coordinates,
            location: project?.location,
          }
    )
  }, [project])

  return (
    <div style={{padding: '15px'}}>
      {contextHolder}
      <Form
        form={form}
        labelCol={{span: 16, flex: '150px'}}
        wrapperCol={{span: 48, flex: 1}}
        layout="horizontal"
        style={{
          width: 800,
          backgroundColor: 'white',
          border: 'double 6px #fa8c16',
          padding: '15px',
        }}
        name="wrap"
        labelAlign="left"
        labelWrap
        colon={false}
        validateMessages={validateMessages}
        onFinish={async (formState) => {
          let result: {success: true; id: number} | {success: false; error: any}
          const editedProject: Omit<Project, 'id'> = {
            name: formState.name,
            description: formState.description,
            ownerId: user.id,
            elements: project ? project.elements : [],
            photo: formState.projectImage
              ? formState.projectImage.slice(formState.projectImage.lastIndexOf('/'))
              : null,
            //coordinates: formState.coordinates,
            location: formState.location,
          }
          let image: MapImage | undefined = undefined
          if (imageExtractorRef.current && formState.location.map) {
            image = await imageExtractorRef.current()
          }
          if (project) {
            result = await projectsService.editProject({...project, ...editedProject}, image)
          } else {
            result = await projectsService.createProject(editedProject, image)
          }
          if (result.success) {
            submit(result.id ? {id: String(result.id)} : null, {
              method: 'post',
            })
            // submit(null, {method: 'post', action: `/projects/${result.id}/edit/plot`})
            revalidator.revalidate()
          } else if (result.success === false) {
            messageApi.open({
              type: 'error',
              content: result.error?.message,
            })
          }
        }}
      >
        <Form.Item
          className="editor-fields-name"
          name="name"
          label={intl.formatMessage({id: 'projectName'})}
          rules={[{required: true}]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          className="editor-fields-name"
          name="description"
          label={intl.formatMessage({id: 'projectDescription'})}
        >
          <Input.TextArea />
        </Form.Item>
        {/* <Form.Item
          className="editor-fields-name"
          name="coordinates"
          label={intl.formatMessage({id: 'projectCoordinates'})}
        >
          <Input />
        </Form.Item> */}

        <Form.Item
          className="editor-fields-name"
          label={intl.formatMessage({id: 'chooseProjectImage'})}
          name="projectImage"
          valuePropName="selectedUrl"
          trigger="onUrlSelected"
        >
          <ImageSelect
            urls={[urlProjectPhoto0, urlProjectPhoto1, urlProjectPhoto2, urlProjectPhoto3]}
          />
        </Form.Item>

        <Form.Item
          className="editor-fields-location"
          label={intl.formatMessage({id: 'locationReference'})}
          name="location"
          valuePropName="chosenLocation"
          getValueFromEvent={getLocalization}
          tooltip={{
            title: intl.formatMessage({id: 'locationReferenceInfo'}),
            icon: <InfoCircleOutlined />,
          }}
          //style={{minWidth: '500px'}}
        >
          <LocationInput
            // currentLocation={project?.location}
            onMapImageExtractorReady={(extractor) => {
              imageExtractorRef.current = extractor
            }}
          />
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" type="primary">
            {intl.formatMessage({id: 'save'})}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
